module.exports = __webpack_public_path__ + "img/pr-4.ff95808e.png";